import store from '@/store/index.js'
import { getSession, setSession } from '@/utils/storage'

/** 拼接字典缓存的key
 *  字典缓存key机制请参看：@/components/api/api.js/setDictCache
 */
export const getDictStorageKey = key => {
    const tenantCode = store.getters.currentTenant.tenantCode
    const locale = store.getters.locale || 'zh-CN'
    const LINKSYM = '#'
    return [tenantCode, locale, key ?? ''].join(LINKSYM)
}

/** 获取字典缓存 */
export function getDictCache(keysStr) {
    if (!keysStr) {
        return {
            result: {},
            passKeys: '',
        }
    }
    const keys = keysStr.split(',')
    const result = {}
    const passKeys = []
    keys.forEach(key => {
        const val = getSession(getDictStorageKey(key))
        if (val) {
            result[key] = val
        } else {
            passKeys.push(key)
        }
    })
    return {
        result,
        passKeys: passKeys.join(','),
    }
}
/** 设置字典缓存 */
export function setDictCache(map) {
    Object.keys(map).forEach(key => {
        setSession(getDictStorageKey(key), map[key])
    })
}

/** 清空字典缓存*/
export const clearDictCache = function () {
    try {
        const prefix = getDictStorageKey('')
        const keys = []
        // 收集字典
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i)
            if (key.startsWith(prefix)) keys.push(key)
        }
        // 删除字典
        keys.forEach(key => sessionStorage.removeItem(key))
    } catch (err) {
        console.error(err)
    }
}
